import { Pipe, PipeTransform } from '@angular/core';
import { MailMergeItem } from '@schoolbelle/api/letter';
import { forEach } from 'lodash-es';


// see https://stackoverflow.com/questions/33781510/how-to-replace-in-javascript

@Pipe({
  name: 'mailmerged'
})
export class MailmergedPipe implements PipeTransform {

  transform(value: string, item: MailMergeItem): string {
    if (typeof value === 'string' && item && typeof item.mm_data === 'object') return this.applyMailmerge(value, item);
    return value || '';
  }
  applyMailmerge (str:string, item:MailMergeItem):string {
    forEach(item.mm_data, (val, key)=>{
      if (val) str = str.replace(new RegExp(`\{\{${key}\}\}`, 'ig'), ()=>val);
    });    
    return str;
  }


}
